import { useInsightsContainer } from 'components/insights/context';
import { useMutation } from '@apollo/client';
import { UPDATE_USER_PAGE_CONFIG } from 'graphql/insights/mutations/updateUserPageConfig';
import { Page } from 'app/modules/insights/types/Page';
import Logger from 'utils/logger';

export const useUpdateMetricsUserConfiguration = (page: Page) => {
  const {
    userPageConfiguration,
    setUserPageConfiguration,
  } = useInsightsContainer();

  const [updateUserPageConfig] = useMutation(UPDATE_USER_PAGE_CONFIG);

  const updateMetricsUserConfiguration = (
    newDndMetrics: { expanded: boolean; metricKey: string }[],
  ) => {
    updateUserPageConfig({
      variables: {
        pageId: page.id,
        configuration: JSON.stringify(newDndMetrics),
      },
    })
      .then((res) => {
        const newUserPageConfiguration = {
          ...userPageConfiguration,
        };
        newUserPageConfiguration[page.id] = JSON.parse(
          res.data.UpdateUserPageConfig.userPageConfiguration,
        );
        setUserPageConfiguration(newUserPageConfiguration);
      })
      .catch((e) => {
        Logger.error(e);
      });
  };

  return { updateMetricsUserConfiguration };
};
